import { END, eventChannel } from 'redux-saga';
import { call, put, take, takeEvery } from 'redux-saga/effects';
import { SETUP_USER_WEB_SOCKET, saveCredentials } from './actions';

let webSocket;

function createEventChannel(channelId) {
  return eventChannel(emit => {
    function createWebSocketConnection() {
      webSocket = new WebSocket(`${process.env.REACT_APP_WEB_SOCKET}?clientId=${channelId}`);

      webSocket.onopen = () => {
        console.info('Opening User Websocket');
      };

      webSocket.onerror = error => {
        console.info('ERROR USER: ', error);
      };

      webSocket.onmessage = e => {
        return emit({ data: JSON.parse(e.data) });
      };

      webSocket.onclose = e => {
        if (e.code === 1005) {
          console.info('USER WebSocket: closed');
          emit(END);
        } else {
          console.info('USER Socket is closed Unexpectedly. Reconnect will be attempted in 1 second.', e.reason);
          setTimeout(() => {
            createWebSocketConnection();
          }, 1000);
        }
      };
    }
    createWebSocketConnection();

    return () => {
      console.info('Closing USER Websocket');
      webSocket.close();
    };
  });
}

export function* initializeUserWebSocketsChannel({ channelId }) {
  const channel = yield call(createEventChannel, channelId);
  while (true) {
    const { data } = yield take(channel);
    switch (data.action) {
      case 'CREDENTIALS':
        yield put(saveCredentials({ ...data }));
        break;
      default:
        break;
    }
  }
}

export default function* watchUserSocket() {
  yield takeEvery(SETUP_USER_WEB_SOCKET, initializeUserWebSocketsChannel);
}
